<template>
  <button
    type="button"
    class="jade-action-button"
    :class="computedClassName"
    aria-label="jade-action-button"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div
      v-if="icon"
      class="jade-action-button__icon-wrapper"
    >
      <jade-icon
        color="current-color"
        size="medium"
        :use="icon"
      />
    </div>
    <span
      v-show="$slots.default"
      class="jade-action-button__label"
    >
      <jade-text
        color="current-color"
        variant="text-medium"
        weight="semibold"
      >
        <slot></slot>
      </jade-text>
    </span>
    <div
      v-if="shouldDisplayCounter"
      class="jade-action-button__counter"
      :class="{ 'is-active': active }"
    >
      <jade-badge
        voice="brand"
        variant="text"
      >
        {{ counter }}
      </jade-badge>
    </div>
    <div
      v-if="dropdownIndicator"
      class="jade-action-button__icon-wrapper"
    >
      <jade-icon
        size="medium"
        use="chevron-down"
        color="current-color"
      />
    </div>
  </button>
</template>

<script>
export default {
  name: 'JadeActionButton',
  components: {
    JadeIcon: () => import('../JadeIcon/index.vue'),
    JadeText: () => import('../JadeText/index.vue'),
    JadeBadge: () => import('../JadeBadge/index.vue')
  },
  props: {
    active: Boolean,
    counter: [Number, String],
    dropdownIndicator: Boolean,
    icon: String
  },
  computed: {
    shouldDisplayCounter () {
      return this.counter !== undefined
    },
    computedClassName () {
      return {
        'is-active': this.active
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/action-button.css';
</style>
